import { i18nMoney } from 'wanderu-i18n';
import { SnowplowService } from 'wanderu-service-analytics';

function fireTripBookedStructuredEvent(props) {
    const {
        category,
        currency,
        id,
        itinerary,
        processingId,
        price,
        quantity,
        url,
    } = props;

    const property = {
        category,
        currency,
        id,
        itinerary_id: itinerary,
        processing_id: processingId,
        price,
        quantity,
    };

    if (category === 'deeplink') {
        property.url = url;
    }

    SnowplowService.fireStructuredEventWithBatchId({
        action: 'click',
        category: 'react_tripsummary',
        label: 'book_button',
        property,
    });
}

function firePageLoadEvent(outboundTripId, returnTripId) {
    let itineraryId = returnTripId
        ? `${outboundTripId}||${returnTripId}`
        : outboundTripId;

    SnowplowService.fireStructuredEventWithBatchId({
        action: 'loaded',
        category: 'react_tripsummary',
        property: {
            is_one_way: !returnTripId,
            itinerary_id: itineraryId,
        },
    });
}

function changeTripButtonClicked({ tripId }) {
    SnowplowService.fireStructuredEventWithBatchId({
        action: 'click',
        category: 'react_tripsummary',
        label: 'change_trip',
        property: {
            trip_id: tripId,
        },
    });
}

function initializeTransactionObject(
    currency,
    totalPrice,
    itineraryUUID,
    affiliateId,
    trackingId,
) {
    SnowplowService.addTransaction({
        affiliateId,
        affiliation: 'react_tripsummary',
        currency,
        processingId: itineraryUUID,
        total: totalPrice,
        trackingId,
    });
}

function addTransactionItem(trip, opts) {
    const {
        currency,
        isNativeData,
        seats,
        itinerary,
        itineraryUUID,
        affiliateId,
        trackingId,
        url,
    } = opts;
    const {
        pricing,
        tripId,
    } = trip;

    const tripIdWithoutDate = tripId.split(',').slice(0, 3).join(',');
    const perSeatPrice = i18nMoney(pricing).getTotalPrice() / seats;
    const isNative = isNativeData.includes(trip.tripId);
    const category = isNative
        ? 'wanderu_native'
        : 'deeplink';

    SnowplowService.addTransactionItem({
        affiliateId,
        category,
        currency,
        name: tripIdWithoutDate,
        processingId: itineraryUUID,
        price: perSeatPrice,
        quantity: seats,
        sku: tripId,
        trackingId,
    });

    fireTripBookedStructuredEvent({
        category,
        currency,
        id: tripId,
        itinerary,
        processingId: itineraryUUID,
        price: perSeatPrice,
        quantity: seats,
        url,
    });
}

function submitTransactionObject() {
    SnowplowService.trackTransaction();
}

function singleBookingSubmitted(opts) {
    const {
        currency,
        totalPrice,
        itineraryUUID,
        trips,
        affiliateId,
        trackingId,
    } = opts;

    initializeTransactionObject(
        currency,
        totalPrice,
        itineraryUUID,
        affiliateId,
        trackingId,
    );

    trips.forEach((trip) => addTransactionItem(trip, opts));

    submitTransactionObject();
}

let hasInitializedTransactionObject = false;
let allTripIdsList;
let unloadListenerId;
function recordMultiBookingTransaction(opts) {
    const {
        currency,
        totalPrice,
        itineraryUUID,
        allTripIds,
        trip,
        affiliateId,
        trackingId,
    } = opts;

    if (!hasInitializedTransactionObject) {
        hasInitializedTransactionObject = true;
        unloadListenerId = window.addEventListener(
            'beforeunload',
            endMultiBookingTransaction,
        );
        allTripIdsList = new Set(allTripIds);
        initializeTransactionObject(
            currency,
            totalPrice,
            itineraryUUID,
            affiliateId,
            trackingId,
        );
    }

    addTransactionItem(trip, opts);
    allTripIdsList.delete(trip.tripId);

    if (allTripIdsList && allTripIdsList.size === 0) {
        endMultiBookingTransaction();
    }
}

function resetMultiBookingTracking() {
    allTripIdsList = undefined;
    hasInitializedTransactionObject = false;

    if (unloadListenerId) {
        window.removeEventListener(unloadListenerId);
        unloadListenerId = undefined;
    }
}

function endMultiBookingTransaction(transaction) {
    if (hasInitializedTransactionObject) {
        submitTransactionObject(transaction);
    }
    resetMultiBookingTracking();
}

function loadTripSummaryFareNames(tripFareNames = {}) {
    SnowplowService.fireStructuredEventWithBatchId({
        action: 'loaded',
        category: 'react_tripsummary',
        label: 'trip_fares',
        property: {
            fares_available: tripFareNames,
        },
    });
}

export {
    changeTripButtonClicked,
    endMultiBookingTransaction,
    firePageLoadEvent,
    loadTripSummaryFareNames,
    recordMultiBookingTransaction,
    singleBookingSubmitted,
};

const externalFunctions = {
    changeTripButtonClicked,
    endMultiBookingTransaction,
    firePageLoadEvent,
    loadTripSummaryFareNames,
    recordMultiBookingTransaction,
    singleBookingSubmitted,
};

export default externalFunctions;
